<template>
    <div class="">
        <input type="checkbox" :id="id" @change="change" class="" ref="input">
        <label v-if="label" :for="id" class="">{{label}}</label>
    </div>
</template>

<script>
    import InputBase from './InputBase';

    export default {
        mixins: [InputBase],
        methods: {
            change: function (value) {
                    this.$emit('change', value);
            },
        },
        data () {
            return {
                id: null,
            }
        },
        mounted () {
            this.id = this._uid;
        },
        props: ["label"]
    };
</script>



// WEBPACK FOOTER //
// src/public_app/elements/Checkbox.vue